import { render, staticRenderFns } from "./IsisFab.vue?vue&type=template&id=44b88f4c&scoped=true&"
import script from "./IsisFab.vue?vue&type=script&lang=js&"
export * from "./IsisFab.vue?vue&type=script&lang=js&"
import style0 from "./IsisFab.vue?vue&type=style&index=0&id=44b88f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b88f4c",
  null
  
)

export default component.exports